import React, { useRef } from 'react'
import { GoogleMap, Marker, LoadScript } from '@react-google-maps/api'

interface PropsType {
  latitude: string
  longitude: string
}

const ProjectDetailsGoogleMapLocation: React.FC<PropsType> = ({ latitude, longitude }) => {
  const mapRef = useRef(null)

  const position = {
    lat: parseInt(latitude),
    lng: parseInt(longitude),
  }

  const handleLoad = (map: any) => {
    mapRef.current = map
  }

  const containerStyle = {
    height: '30vh',
    width: '100%',
    borderRadius: '10px'
  }

  return (
    <div className='full-width'>
      <LoadScript googleMapsApiKey={process.env.MAPS_API_KEY}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          zoom={9}
          onLoad={handleLoad}
          center={position}
        >
          <Marker position={position} />
        </GoogleMap>
      </LoadScript>
    </div>
  )
}

export default React.memo(ProjectDetailsGoogleMapLocation)
